export default __webpack_public_path__ + "static/media/tshirt.3b4bc464.png";